module.exports = __webpack_public_path__ + "img/icon-new.ed2d44ff.svg";